/**
 * Polish Wave 6 Fix Wave 4 — org guard pure function
 *
 * Extracted so it can be unit-tested without React (no @testing-library/react
 * is available per J1-Deferred-HIGH in roros-qa).
 *
 * Returns true when we should render <NoOrganizationAccess> instead of <AppRouter>.
 * Conditions:
 *   - Org store has finished initialising (not mid-hydration)
 *   - Not currently loading
 *   - Zero active org memberships
 *   - User is NOT a super-admin (super-admins bypass org-scope checks)
 */
export interface OrgGuardParams {
  initialized: boolean;
  isLoading: boolean;
  orgsCount: number;
  isSuperAdmin: boolean;
}

export function shouldShowNoOrgScreen({
  initialized,
  isLoading,
  orgsCount,
  isSuperAdmin,
}: OrgGuardParams): boolean {
  if (!initialized || isLoading) return false;
  if (isSuperAdmin) return false;
  return orgsCount === 0;
}
